import { ActionType } from '../../types/action';

export const listPermission = {
  resource: 'action',
  action: ActionType.READ,
};

export const Action = {
  list: listPermission,
};
